// extracted by mini-css-extract-plugin
export default {"blender_bottle_item":"JF","blender_bottle_img":"KF","blender_bottle_info":"LF","blender_bottle_title":"MF","blender_bottle_bold":"NF","blender_bottle_usual":"OF","blender_bottle_item_mob":"PF","addbutton":"QF","blender_bottle_title_mob":"RF","blender_bottle_bold_mob":"SF","blender_bottle_usual_mob":"TF","bolder":"UF","bottom_margin_4":"VF","bottom_margin_16":"WF"};
    if(module.hot) {
      // 1713996747631
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  